import styled from 'styled-components';

export const S = {
  FooterTextWrap: styled.div``,
  ForgotPasswordTextWrap: styled.div`
    padding-top: 25px;
    margin-bottom: -25px;
  `,
};
